<template>
  <v-container>
    <v-card>
      <v-toolbar dark color="primary">

        <v-toolbar-title>PBS Personel Seçimi</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <!-- <v-card-title class="headline">
          Unvan Seçimi
        </v-card-title> -->

      <v-card-text>

        <v-autocomplete v-model="selectedUser" :items="users" :loading="loading" :search-input.sync="search"
          :persistent-placeholder="true" placeholder="En az 3 harf girerek kullanıcı arayınız." item-text="username"
          item-value="personelId" label="Kullanıcı Seç" clearable hide-no-data hide-details>
          <template v-slot:item="{ item }">
     <v-list-item-avatar>
            <v-img :src="item.resim"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title >{{ item.ad + ' ' + item.soyad }}({{ item.kadroUnvan }})</v-list-item-title>
              <v-list-item-subtitle>{{item.ustBirim}}</v-list-item-subtitle>
          </v-list-item-content>
        
          
          </template>

        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" v-if="selectedUser" text @click="saveSelected">Seçilenleri Aktar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import FilterUserService from "@/services/FilterUserService";
export default {
  data() {
    return {
      users: [],          // API’den gelen kullanıcı listesi
      selectedUser: null, // seçilen kullanıcı id
      search: "",         // autocomplete arama inputu
      loading: false      // yükleniyor göstergesi
    };
  },
  props: {


    onlyNameSurname: {
      type: Boolean,
      default: false
    },



  },
  watch: {

    // Kullanıcı arama inputu değiştikçe API çağrısı yap
    search(val) {
      if (val && val.length > 2) { // 2 karakterden sonra arama başlasın
        //this.fetchUsers(val);
        console.log("SEarch Value:", val);
        this.getUsers(val)
      } else {
        this.users = [];
      }
    }
  },
  methods: {
    saveSelected() {

      if (this.selectedUser) {
        let user = this.users.find(m => m.personelId == this.selectedUser)
        console.log("user", user);
        if (this.onlyNameSurname) {
          user = user.adSoyad;
        }

        this.$emit("selectedChange", [user]);
        this.selectedUser = "";
      }
      else {
        this.$toast.warning("Lütfen kullanıcı seçiniz !");

      }



    },

    getUsers(query) {
      try {
        this.loading = true;
        FilterUserService.listPBSPersonelByParam(query).then((result) => {

         // console.log("listPBSPersonelByParam Response:", result);
          let pers = result.data.map(x => { return { ...x, username: x.ad + " " + x.soyad } });

          this.users = pers;
        }).catch((err) => {
          //console.error("APIxx hatası:", err);
        }).finally(() => {
          this.loading = false;
        });


      } catch (error) {
        console.error("API hatası:", error);
      }

    },

    async fetchUsers(query) {
      this.loading = true;
      try {
        //console.error("API hatası:", query);
        const response2 = await FilterUserService.listPBSPersonelByParam(query);
        this.users = response2.data;
        // Örnek API isteği (sen kendi endpointini koyabilirsin)
        // const response = await FilterUserService.listPBSPersonelByParam(query);
        //     console.error("API response:", response);
        //   this.users = response.data;

        // const response = await axios.get(
        //   `https://jsonplaceholder.typicode.com/users?q=${query}`
        // );
        // this.users = response.data;


        //    const response = await axios.get(
        //   `https://localhost:7211/api/FilterUser/listPBSPersonelByParam/${query}`
        // );
        // this.users = response.data;

      } catch (error) {
        console.error("API hatası:", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>